import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import { getFriendlyError } from '../../utils/friendlyError';

const SalonSwitcher = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { user, role, tenantId, selectSalon } = useAuth();
  const { showToast } = useToast();

  const salons = user?.salons || [];
  const visible = role === 'SALON_STAFF' && salons.length >= 2;

  const switchMut = useMutation({
    mutationFn: (nextTenantId) => selectSalon(nextTenantId),
    onSuccess: () => queryClient.invalidateQueries(),
    onError: (err) => showToast(getFriendlyError(err, t('staff.switchSalonFailed')), 'error'),
  });

  if (!visible) return null;

  return (
    <select
      value={tenantId || ''}
      onChange={(e) => switchMut.mutate(e.target.value)}
      disabled={switchMut.isPending}
      className="max-w-[9.5rem] truncate rounded-lg border border-zinc-300 bg-zinc-50 px-2 py-1.5 text-sm dark:border-zinc-700 dark:bg-zinc-950 sm:max-w-[200px]"
      aria-label={t('staff.activeSalon')}
    >
      {salons.map((s) => (
        <option key={s.tenantId} value={s.tenantId}>
          {s.businessName}
        </option>
      ))}
    </select>
  );
};

export default SalonSwitcher;
